import usePathname from '@shared/hooks/usePathname';
import React, { createContext, useContext } from 'react';
const PathnameContext = createContext<string>('');

export const usePathnameContext = () => {
  const pathname = useContext(PathnameContext);

  return pathname;
};

interface PathnameProviderProps {
  children: React.ReactNode;
}

const PathnameProvider = ({ children }: PathnameProviderProps) => {
  const pathname = usePathname();

  return (
    <PathnameContext.Provider value={pathname}>
      {children}
    </PathnameContext.Provider>
  );
};

export default PathnameProvider;
